import {
  GET_ALL_JOB_CARDS_TEMPLATE_FIELDS,
  GET_ALL_JOB_CARDS_TEMPLATE_FIELDS_FAILED,
  ADD_JOB_CARDS_TEMPLATE_CUSTOM_FIELDS
} from '../../actions/jobCardsTemplate';

export default function jobCardsTemplate(state = {}, action) {
  switch (action.type) {
    case GET_ALL_JOB_CARDS_TEMPLATE_FIELDS:
      return Object.assign({}, state, action.payload);
    case GET_ALL_JOB_CARDS_TEMPLATE_FIELDS_FAILED:
      return Object.assign({}, state, action.payload);
    case ADD_JOB_CARDS_TEMPLATE_CUSTOM_FIELDS:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/jobCardsTemplate/index.js